import { useRef, useEffect } from 'react';

const useMountTime = (): null | Date => {
  const startTime = useRef<Date | null>(null);

  useEffect(() => {
    startTime.current = new Date();
  }, []);

  return startTime.current;
};

export default useMountTime;
